import styled from 'styled-components'

const StyledFaqContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 15px 32px;

  p {
    &:first-child {
      margin-top: 0;
    }
  }
`

export const TypeContent = () => (
  <StyledFaqContent>
    <p>
      Our audience appreciates reading about the latest research and innovation
      in biomedical research, clinical trials, medical technologies, and the
      like. Unlike scientific journals or pre-print servers, the TrialSite
      audience prefers jargon free, accessible writing that can be understood by
      laypeople. Biomedical research is a massive topic that affects all our
      lives and health and there are many aspects to it worthy of writing about.
      These include the science, politics, economics, and social aspects of the
      industry.
    </p>
  </StyledFaqContent>
)

export const PrePrintContent = () => (
  <StyledFaqContent>
    <p>
      TrialSite is not a pre-print server and we do not publish research papers
      verbatim. Instead, we encourage our writers to link to research papers
      published on pre-print servers or science journals, and “editorialize
      their work” for the TrialSite audience. In this way, you as a researcher
      can bring attention to your scientific articles published elsewhere.
    </p>
  </StyledFaqContent>
)
export const WhoReadsContent = () => (
  <StyledFaqContent>
    <p>
      Our audience is global, and includes professionals working at every major
      pharmaceutical, biotech, government, NGO, investment firm and healthcare
      provider involved in the business of healthcare and medical research. We
      currently get around 75,000 visitors per day.
    </p>
  </StyledFaqContent>
)
export const BuildFollowingContent = () => (
  <StyledFaqContent>
    <p>
      The best way to build a following on TrialSite is to publish informative,
      well written articles that capture the audience’s imagination. Anyone who
      reads your writing on TrialSite can follow you, and you will be notified
      as your follower count grows. You can increase the growth of your
      following by promoting your published work on other channels you have
      access too. EG: publish on TrialSite and share links to your work in
      Twitter, Facebook or elsewhere.
    </p>
  </StyledFaqContent>
)
export const HowGetWritingContent = () => (
  <StyledFaqContent>
    <p>
      We read and review all writing that is submitted for publication on the
      home page where it will get maximum exposure to our audience. If we feel
      it’s a good fit for our audience, we will publish it there. If not, it
      will remain accessible on your personal dashboard and can still be read
      and shared by you to any audience you like. Additionally, your followers
      will be notified by email about your work. If you want to maximize your
      chance of getting on the home page, simply produce good writing that fits
      with the criteria our audience is looking for.
    </p>
  </StyledFaqContent>
)
export const WhyShouldContent = () => (
  <StyledFaqContent>
    <p>
      TrialSite is industry specific and focused purely on the world of
      biomedical research. If you want to bring attention to your work with an
      audience that matters to your industry, there is no better platform to
      publish on than TrialSite.
    </p>
  </StyledFaqContent>
)

export const MailTo = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
`
export const AssistContent = () => (
  <StyledFaqContent>
    <p>
      If you would like to discuss how we might assist you in writing about your
      work for a fee;
      <br />
      <MailTo href="mailto:info@trialsitenews.com">
        <strong>Contact Us</strong>
      </MailTo>
    </p>
  </StyledFaqContent>
)
